module.exports = __webpack_public_path__ + "d4b59ba06cd42327c9d970a3b3142439.png";